import { type JSX } from "react";
import styles from "@/components/ClientOfferView.module.css";
import type { OfferSectionProps } from "@/components/offer/offerDocumentTypes";

const MATERIALS_OWNERSHIP_TEXT: Record<string, string> = {
  client: "Materiały po stronie klienta.",
  contractor: "Materiały po stronie wykonawcy.",
  shared: "Materiały częściowo po stronie klienta, częściowo po stronie wykonawcy.",
  split: "Materiały częściowo po stronie klienta, częściowo po stronie wykonawcy.",
  tbd: "Kwestia materiałów do ustalenia.",
};

export function MaterialsSection({ offerData }: OfferSectionProps): JSX.Element {
  const ownershipRaw = offerData.materialsOwnership?.trim().toLowerCase() ?? "";
  const ownership = MATERIALS_OWNERSHIP_TEXT[ownershipRaw] ?? MATERIALS_OWNERSHIP_TEXT.contractor;
  const notes = offerData.materialsNotes?.trim() || "";
  const short = offerData.templateType === "quick";

  return (
    <section className={styles.assumptions}>
      <div>
        <h2 className={styles.assumptionsHeading}>
          Materiały
          <br />i logistyka
        </h2>
      </div>
      <div className={styles.assumptionsList}>
        <div className={styles.assumptionItem}>{ownership}</div>
        {!short && notes ? <div className={styles.assumptionItem}>{notes}</div> : null}
      </div>
    </section>
  );
}
